const getters = {
  sidebarMin: state => state.sidebarMin,
  sidebarActive: state => state.sidebarActive,
  sidebarMobile: state => state.sidebarMobile,
  windowWidth: state => state.windowWidth,
  highContrast: state => state.highContrast,
  fontLarger: state => state.fontLarger,
};

export default getters
